import React from "react";
import { motion } from "framer-motion";
import { zodiacSigns } from "../utils/zodiac";
import "./ZodiacGrid.css";

export const ZodiacGrid = ({ onSignClick, loading }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.4 },
    },
  };

  return (
    <section className="zodiac-grid-section" id="zodiac-grid">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          All Zodiac Signs
        </motion.h2>

        <motion.div
          className="zodiac-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {zodiacSigns.map((sign) => (
            <motion.div
              key={sign.name}
              className="zodiac-card"
              variants={itemVariants}
              whileHover={{ y: -8, scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => {
                if (!loading) {
                  onSignClick(sign);
                }
              }}
              disabled={loading}
            >
              <span className="zodiac-card-emoji">{sign.emoji}</span>
              <h3 className="zodiac-card-name">{sign.name}</h3>
              <p className="zodiac-card-dates">{sign.dateRange}</p>
              <div className="zodiac-card-symbol">{sign.symbol}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
